/* eslint-disable react/jsx-boolean-value */
/* eslint-disable  @typescript-eslint/no-floating-promises */
/* eslint-disable  react-hooks/exhaustive-deps */
/* eslint-disable  import/order */
/* eslint-disable import/no-named-as-default */

import React, { FC, useCallback, useEffect, useMemo, useState } from 'react';
import { Col, Dropdown, MenuProps, Row, Tooltip, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { Button, Hint, Table, Tabs } from '~/components';
import { useFieldMap } from '~/controllers/pricing';
import { ApplicationPayload } from '~/types/ApplicationPayload';
import { CustomPricing, ProductMap } from '~/types/CustomPricing';
// import { servicesFormName, servicesStepKey } from './SelectServices';
import { servicesData } from '~/mockJson/productsD2C';
import { useGetApplication, useSelectStep } from '~/controllers/wizard';
import { useAmendment } from '~/controllers/amendment';
import { useGetDraft, useSaveDraft } from '~/controllers/draft';
import { useRefScrollTo } from '~/hooks/useRefScrollTo';
import { ColumnsType, TablePaginationConfig } from 'antd/lib/table';
import { EllipsisOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import AdministratorAdd from '~/components/views/ServicesView/AdministratorAdd';
import createUid from '~/utils/createUid';
import DeleteConfirmationModal from '~/components/DeleteConfirmationModal';
import Form from '~/components/WizardForm';
import { useLocation } from 'react-router';
import { Draft } from '~/types/Draft';
import _, { cloneDeep } from 'lodash';
import Section from '~/layouts/Section ';
import { setAddingExistingUserValues } from '~/slices/state';
import { useGetContactsApi, useMutateContactsApi } from '~/controllers/contacts';
import { useSaveCardHolderDetails } from '~/controllers/cardholder';
import {
  contactObjCreation,
  getUpdatedContact,
  getUpdatedInitialUsersData,
  getUpdatedUsersData,
  missingFieldsBackupHandler,
  missingFieldsHandler,
} from '~/utils/contacts';
import { getContacts } from '~/api/contacts';
import { getStagePayload } from '~/utils/getStagePayload';
import { hasSoftDeclineFields } from '~/utils/softDeclinesFields';

export type ServicesDraft = {
  services: Partial<ApplicationPayload['users']>;
  productMap?: ProductMap;
  additionalConfigurations?: CustomPricing;
  productMapTemp?: any; // Prop to store some temporary data
  isAgreeWithServicesTermsAndConditions: boolean;
};

export type AdministratorPayload = {
  selfServiceUsers: AdministratorDataType[];
  dataExpenseManagementAndVirtualCardUsers: AdministratorDataType[];
};

export type AdministratorDataType = {
  uid: string;
  firstName: string | undefined;
  secondName: string | undefined;
  lastName: string | undefined;
  phoneNo: string | undefined;
  mobileNo: string | undefined;
  email: string | undefined;
  passport: any;
  emiratesId: any;
  visa: any;
  nationality: any;
  dateOfBirth: string | undefined;
  role: string[] | undefined;
  formRole: string | undefined;
  userOrder?: any;
  userRoles?: any;
  salesForceUser?: any;
  contactId?: any;
  missingFields?: any;
};

const Administrator: FC<any> = (props) => {
  const { t } = useTranslation('administrator');
  const [form] = Form.useForm();
  const draftMutation = useSaveDraft();
  const [isSpinning, setIsSpinning] = useState<any>(false); // This is to get all the email address of all the administrators
  const applicationQuery = useGetApplication();
  const stagePayload = getStagePayload.wizard(applicationQuery.data);
  const activeStep = stagePayload?.activeStep;
  const location = useLocation();
  const formName = location.pathname.split('/')[location.pathname.split('/')?.length - 1];
  const dispatch = useDispatch();
  const contactMutation = useMutateContactsApi();

  const selectedContact = useSelector((state: any) => state?.state?.selectedContact);
  const { isAmendment, isProductLocked } = useAmendment();
  const virtualCardProducts = ['DIGITAL_TRAVEL_PAYMENT', 'DIGITAL_BUSINESS_PAYMENT'];
  const products = applicationQuery?.data?.payload?.servicesDetails?.products || [];
  const someVirtualEnabled = products.some(
    (product: any) => virtualCardProducts.includes(product?.id) && product?.enabled,
  );
  const anyVirtualLocked = virtualCardProducts.some((id) => isProductLocked(id as any));
  const isVcpEnabled = someVirtualEnabled && !anyVirtualLocked;
  const isSspDisabled = isAmendment;
  const isVcpDisabled = !isVcpEnabled;
  const areBothTabsDisabled = isSspDisabled && isVcpDisabled;

  // Tabs related variables
  const [activeTab, setActiveTab] = useState<string | 'selfServiceUsers' | 'dataExpenseManagementAndVirtualCardUsers'>(
    isAmendment ? 'dataExpenseManagementAndVirtualCardUsers' : 'selfServiceUsers',
  ); // Default Tab selected
  const tabsErrors: any[] = [];
  const isActiveTabDisabled =
    (activeTab === 'selfServiceUsers' && isSspDisabled) ||
    (activeTab === 'dataExpenseManagementAndVirtualCardUsers' && isVcpDisabled);
  const onTabsChange = (activeKey: string) => {
    setActiveTab(activeKey);
  };

  useEffect(() => {
    if (activeTab === 'selfServiceUsers' && isSspDisabled && !isVcpDisabled) {
      setActiveTab('dataExpenseManagementAndVirtualCardUsers');
    } else if (activeTab === 'dataExpenseManagementAndVirtualCardUsers' && isVcpDisabled && !isSspDisabled) {
      setActiveTab('selfServiceUsers');
    }
  }, [isSspDisabled, isVcpDisabled]);

  // TOD0 : Handle getting data from the backend
  const servicesDetailsData = useGetDraft('services.adminstrator');
  const { data: draftData, isLoading }: any = servicesDetailsData;
  const { data: applicationData, isLoading: applicationLoading } = useGetApplication();
  const [dataSource, setDataSource] = useState<AdministratorPayload>({
    selfServiceUsers: [],
    dataExpenseManagementAndVirtualCardUsers: [],
  });
  const [selectedValue, setSelectedValue] = useState({});
  const [firstRender, setFirstRender] = useState(true);
  const [isAllDataExpenseManagementUsersAdded, setIsAllDataExpenseManagementUsersAdded] = useState(true);
  const [isAllSSPUsersAdded, setIsAllSSPUsersAdded] = useState(true);

  useEffect(() => {
    const newDataSource = draftData?.users ||
      (!_.isEmpty(applicationData?.payload?.users) && applicationData?.payload?.users) || {
        selfServiceUsers: [],
        dataExpenseManagementAndVirtualCardUsers: [],
      };
    if (newDataSource) {
      setDataSource(newDataSource);
    }
  }, [isLoading, draftData, applicationLoading, applicationData]);

  useEffect(() => {
    if (Object?.values(dataSource)?.flat()?.length && firstRender) {
      setFirstRender(false);
      const initialDataRender = getUpdatedInitialUsersData({
        existedData: dataSource,
      }).then((newData: any) => {
        if (activeStep?.validationState === 'OK') {
          setDataSource(newData);
        } else {
          setDataSource(newData);
          draftMutation.mutateAsync({ stepData: { users: newData } });
        }
      });
    }
  }, [dataSource]);

  useEffect(() => {
    updateForm();
  }, [dataSource]);

  // const dataSource = applicationQuery.data.payload.administrator;

  // Delete modal props
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [isError, setIsError] = useState(false);
  const [selectedDeleteValue, setSelectedDeleteValue] = useState({});
  const [recordIndex, setRecordIndex] = useState(null);
  const isUsersSoftRejected =
    hasSoftDeclineFields(applicationQuery.data, 'users.selfServiceUsers[]') ||
    hasSoftDeclineFields(applicationQuery.data, 'users.dataExpenseManagementAndVirtualCardUsers[]');
  const isDisabledForSoftRejection = isUsersSoftRejected;

  const onDelete = async () => {
    // Handle delete action
    const record: any = { ...selectedDeleteValue };
    const latestContact = await getUpdatedContact(record);
    const newDataSource = { ...dataSource };
    switch (activeTab) {
      case 'selfServiceUsers': {
        newDataSource.selfServiceUsers = newDataSource.selfServiceUsers.filter((r) => {
          return !(r.uid === record?.uid);
        });
        contactMutation.mutate(contactObjCreation(latestContact, { type: 'DELETE', role: 'sspUser' }));
        break;
      }
      case 'dataExpenseManagementAndVirtualCardUsers': {
        newDataSource.dataExpenseManagementAndVirtualCardUsers =
          newDataSource.dataExpenseManagementAndVirtualCardUsers.filter((r) => {
            return !(r.uid === record?.uid);
          });

        newDataSource.dataExpenseManagementAndVirtualCardUsers =
          newDataSource.dataExpenseManagementAndVirtualCardUsers.map((item) => {
            if (record?.userOrder < item?.userOrder) {
              const reOrderNumber = Number(item?.userOrder) - 1;
              return { ...item, userOrder: reOrderNumber };
            }
            return item;
          });
        contactMutation.mutate(contactObjCreation(latestContact, { type: 'DELETE', role: 'virtualUser' }));
        break;
      }
      default:
    }
    const convertedData = convertData(newDataSource);
    await draftMutation.mutateAsync({ stepData: { users: convertedData } });
    setDataSource(convertedData);
    setColumns([...defaultColumns]);
    setDeleteModalVisible(false);
  };

  const onCancel = () => {
    setDeleteModalVisible(false);
  };

  const convertData = (data: any) => {
    const selfServiceUsers = convertUsers(data.selfServiceUsers);
    const dataExpenseManagementAndVirtualCardUsers = convertUsers(data.dataExpenseManagementAndVirtualCardUsers);

    return { selfServiceUsers, dataExpenseManagementAndVirtualCardUsers };
  };

  const updateForm = () => {
    form.setFieldsValue({
      administrator: {
        selfServiceUsers: dataSource?.selfServiceUsers || [],
        dataExpenseManagementAndVirtualCardUsers: dataSource?.dataExpenseManagementAndVirtualCardUsers || [],
      },
    });
  };

  const convertUsers = (data: Partial<AdministratorDataType>[]) => {
    const returnData: AdministratorDataType[] = (data || []).map(
      ({
        uid,
        firstName,
        secondName,
        lastName,
        phoneNo,
        mobileNo,
        email,
        passport,
        emiratesId,
        visa,
        nationality,
        dateOfBirth,
        role,
        formRole,
        userOrder,
        salesForceUser,
        userRoles,
        contactId,
        missingFields,
      }) => {
        const newUid = createUid();
        return {
          uid: uid || newUid,
          name: `${firstName || ''} ${secondName || ''} ${lastName || ''}`.trim(),
          firstName,
          secondName,
          lastName,
          phoneNo,
          mobileNo,
          email,
          passport,
          emiratesId,
          visa,
          nationality,
          dateOfBirth,
          role,
          formRole,
          userOrder,
          salesForceUser,
          userRoles,
          contactId: contactId ?? createUid(),
          missingFields,
        };
      },
    );
    return returnData;
  };

  // const handleView = (record: any) => {
  //   // Handle edit action
  //   console.log('View clicked for record:', record);
  // };

  const handleEdit = (record: any) => {
    // Handle edit action
    console.log('Edit clicked for record:', record);
    setSelectedValue(record);
    dispatch(setAddingExistingUserValues(record));
  };

  const handleDelete = (record: any) => {
    setSelectedDeleteValue(record);
    setDeleteModalVisible(true);
  };
  function onError() {
    setIsError(true);
    setIsSpinning(false);
  }

  function onSuccess() {
    setIsError(false);
    setIsSpinning(false);
  }

  const onSave = async (record: any) => {
    setIsSpinning(true);
    const newRecord = { ...record?.data };
    const newDataSource: any = { ...dataSource };
    const updatedContact = await getUpdatedContact(newRecord);
    const AddOrEdit: any = () => {
      const isEdit = newDataSource[activeTab].find((r: any) => {
        return r.uid === record?.data?.uid;
      });
      const switchNames: any = {
        selfServiceUsers: 'sspUser',
        dataExpenseManagementAndVirtualCardUsers: 'virtualUser',
      };
      return { type: isEdit ? 'EDIT' : 'ADD', role: switchNames[activeTab], data: isEdit ? newRecord : updatedContact };
    };
    const mutation = await contactMutation.mutateAsync(
      contactObjCreation(AddOrEdit()?.data, { type: AddOrEdit()?.type, role: AddOrEdit()?.role }),
      {
        onError,
        onSuccess,
      },
    );
    if (isError) {
      return false;
    }
    switch (activeTab) {
      case 'selfServiceUsers': {
        const recordFound = newDataSource.selfServiceUsers.find((r: any) => {
          return r.uid === record?.data?.uid;
        });

        if (recordFound) {
          // Update the record
          console.log('error');
          newDataSource.selfServiceUsers = newDataSource.selfServiceUsers.map((r: any) => {
            return r.uid === recordFound?.uid
              ? {
                  ...newRecord,
                  // role: newRecord.formRole?.split('&').map((s: string) => s.trim())
                }
              : {
                  ...r,
                  // role: newRecord.formRole?.split('&').map((s: string) => s.trim())
                };
          });
        } else {
          // Push the new record
          newDataSource.selfServiceUsers = [
            {
              ...newRecord,
              // role: newRecord.formRole?.split('&').map((s: string) => s.trim()),
            },
            ...newDataSource.selfServiceUsers,
          ];
        }

        break;
      }
      case 'dataExpenseManagementAndVirtualCardUsers': {
        const recordFound = newDataSource.dataExpenseManagementAndVirtualCardUsers.find(
          (r: any) => r.uid === record?.data?.uid,
        );
        if (recordFound) {
          newDataSource.dataExpenseManagementAndVirtualCardUsers =
            newDataSource.dataExpenseManagementAndVirtualCardUsers.map((r: any) => {
              return r.uid === recordFound?.uid
                ? {
                    ...newRecord,
                    // role: newRecord.formRole?.split('&').map((s: string) => s.trim()),
                    userOrder: recordFound?.userOrder,
                  }
                : {
                    ...r,
                    // role: newRecord.formRole?.split('&').map((s: string) => s.trim()),
                  };
            });
        } else {
          // Push the new record
          newDataSource.dataExpenseManagementAndVirtualCardUsers = [
            ...newDataSource.dataExpenseManagementAndVirtualCardUsers,
            {
              ...newRecord,
              // role: newRecord.formRole?.split('&').map((s: string) => s.trim()),
              userOrder: Number(newDataSource.dataExpenseManagementAndVirtualCardUsers?.length) + Number(1),
            },
          ];
        }

        break;
      }
      default:
    }
    const convertedData = convertData({ ...newDataSource });
    const updatedData = getUpdatedUsersData({ convertedData, newRecord });
    setDataSource(cloneDeep({ ...updatedData }));
    await draftMutation.mutateAsync({ stepData: { users: cloneDeep({ ...updatedData }) } });
    setColumns([...defaultColumns]);
    setSelectedValue({});
    return false;
  };

  const getItems = (record: any, index: any) => {
    const items: any['items'] = [
      {
        key: 'edit',
        label: t('administrator.table.options.editUser'),
        disabled: isActiveTabDisabled,
        onClick: () => {
          setRecordIndex(index);
          handleEdit(record);
        },
      },
      {
        key: 'delete',
        label: t('administrator.table.options.deleteUser'),
        disabled: isDisabledForSoftRejection || isActiveTabDisabled,
        onClick: () => {
          handleDelete(record);
        },
      },
    ];
    return items;
  };

  const defaultColumns: ColumnsType<AdministratorDataType> = useMemo(
    () => [
      {
        title: t('administrator.table.name'),
        dataIndex: 'fullName',
        key: 'fullName',
        render: (text: string, record: any) => (
          <>{`${record.firstName || ''} ${record.secondName || ''} ${record.lastName || ''}`}</>
        ),
      },
      {
        title: t('administrator.table.phone'),
        dataIndex: 'phoneNo',
        key: 'phoneNo',
      },
      {
        title: t('administrator.table.mobile'),
        dataIndex: 'mobileNo',
        key: 'mobileNo',
      },
      {
        title: t('administrator.table.email'),
        dataIndex: 'email',
        key: 'email',
      },
      {
        title: t('administrator.table.passport'),
        dataIndex: 'fullName',
        key: 'fullName',
        width: 100,
        render: (text: string, record: any) => (
          <>{`${
            record?.passport?.documentNumber
              ? record?.passport?.documentNumber || ''
              : record?.emiratesId?.documentNumber || ''
          }`}</>
        ),
      },
      {
        title: '',
        key: 'actions',
        width: 15,
        render: (text, record, index) => (
          <Dropdown menu={{ items: getItems(record, index) }} placement="bottomRight">
            <Button id={`${record.emiratesId}`}>
              <EllipsisOutlined className="rotate-90" />
            </Button>
          </Dropdown>
        ),
      },
    ],
    [t],
  );
  const [columns, setColumns] = useState(defaultColumns);

  const ref = useRefScrollTo();

  const selectStepMutation = useSelectStep();
  const selectStepCall = useCallback(async () => {
    await selectStepMutation.mutateAsync('services.adminstrator');
  }, []);

  useEffect(() => {
    selectStepCall();
  }, []);

  const pagination: Partial<TablePaginationConfig> = { position: ['bottomRight'], pageSize: 4 };

  // Custom validator function to check if the value is an array with at least one element
  const validateArrayNotEmpty = (_: any, value: any) => {
    // console.log('ddddddd');

    if (isAmendment) {
      return Promise.resolve();
    }
    if (!value || value.length === 0) {
      setIsAllSSPUsersAdded(false);
      return Promise.reject(new Error(t('administrator.modal.form.exactly1User')));
    }
    setIsAllSSPUsersAdded(true);
    return Promise.resolve();
  };

  const areAllRolesSelected = (_: any, value: any) => {
    if (isAmendment) {
      return Promise.resolve();
    }
    const rolesSelected = ['Admin', 'senior-manager', 'Manager'];
    const allSSpRoles = value?.map((item: any) => item?.role)?.flat();
    const uniqueRoles = [...new Set(allSSpRoles)];
    const isAllSelected = rolesSelected?.every((item) => uniqueRoles?.includes(item));
    if (!isAllSelected) {
      const errMessage = rolesSelected?.filter((item: any) => !uniqueRoles?.includes(item))?.join('/ ');
      return Promise.reject(new Error(`At least 1 SSP user with (${errMessage}) role/s should be selected`));
    }

    return Promise.resolve();
  };

  // Custom validator function to check if the value is an array with at least 2 elements
  const validateArrayForAtLeastThreeValues = (_: any, value: any) => {
    if (!isVcpEnabled) {
      return Promise.resolve();
    }
    if (!value || !(value.length >= 1 && value.length <= 3)) {
      setIsAllDataExpenseManagementUsersAdded(false);
      return Promise.reject(new Error(t('administrator.modal.form.exactly3Users')));
    }
    setIsAllDataExpenseManagementUsersAdded(true);
    return Promise.resolve();
  };

  function parseAdminData(results: any) {
    return {
      users: {
        ...dataSource,
        virtualCardPortal: dataSource?.dataExpenseManagementAndVirtualCardUsers,
        dataAndExpenseManagement: [],
      },
      services: {},
    }; // TODO: Need to be remove virtualCardPortal and dataAndExpenseManagement from the payload
  }

  const isAddFormDisabled = useMemo(() => {
    /**
     * Only one admin user should be added - Disable the add ssp user button after that
     * Only 2 users should be added for - dataExpenseManagementAndVirtualCardUsers
     */
    // revert ssp
    const isSspUserEnable =
      activeTab === 'selfServiceUsers' &&
      dataSource &&
      dataSource.selfServiceUsers &&
      dataSource.selfServiceUsers.length < 0;
    const isDataExpenseManagementAndVirtualCardUsersEnable =
      activeTab === 'dataExpenseManagementAndVirtualCardUsers' &&
      dataSource &&
      dataSource.dataExpenseManagementAndVirtualCardUsers &&
      dataSource.dataExpenseManagementAndVirtualCardUsers.length > 2;

    if (isSspUserEnable || isDataExpenseManagementAndVirtualCardUsersEnable) {
      return true;
    }
    return false;
  }, [dataSource, activeTab]);

  return (
    <Container ref={ref} isAmendment={isAmendment} isActiveTabDisabled={isActiveTabDisabled}>
      <Form<Draft<'users'>>
        shouldSaveDraft={() => true}
        form={form}
        stepKey="users"
        handleDraftDataBeforeSave={(v) => v}
        parseBeforeSubmit={(values: any) => parseAdminData(values)}
        // name={formName}
        // id={formName}
      >
        {/* Administrator Details */}
        <Typography.Title>{t('administrator.title')}</Typography.Title>
        <Typography.Paragraph className="Administrator-Title">
          {areBothTabsDisabled
            ? t('No portal users are required for this application. You can continue to the next step.')
            : t('administrator.description')}
        </Typography.Paragraph>

        {/* Table Goes Here..... */}
        <Tabs
          activeKey={activeTab}
          defaultActiveKey="first"
          sticky
          centered
          onChange={onTabsChange}
          className="Administrator-Tabs"
        >
          <Tabs.TabPane
            tab={
              <Row gutter={[12, 12]}>
                <Col>
                  <span className="Tabs-Title" data-error={tabsErrors[0] ? 'true' : 'false'}>
                    {t('administrator.tabs.self_service_portal')}
                  </span>
                </Col>
                <Col style={{ marginTop: '5px' }}>
                  <Hint
                    text="The Self-Service Portal is a secure online platform enabling corporate users to manage
card-related activities according to business needs. It serves as a centralized hub where users can
access and manage card products in a user-friendly and efficient manner."
                  />
                </Col>
              </Row>
            }
            key="selfServiceUsers"
            disabled={isAmendment}
          >
            <Table
              id="selfServiceUsersTable"
              dataSource={dataSource?.selfServiceUsers}
              columns={columns}
              pagination={pagination}
              scroll={{ x: true, y: 300 }}
            />
          </Tabs.TabPane>
          <Tabs.TabPane
            tab={
              <span className="Tabs-Title" data-error={tabsErrors[0] ? 'true' : 'false'}>
                <Row style={{ width: '450px' }}>
                  Virtual Card Portal / Data & Expense Management Portal
                  <div style={{ marginLeft: '10px' }}>
                    <Hint
                      text="he Virtual Card Portal is a platform for users to create distinct virtual cards for each
transaction. The portal allows customers to apply enhanced controls for greater security.
The Data & Expense Management Portal is a portal to manage company expenses and generate
comprehensive spending reports."
                    />
                  </div>
                </Row>
              </span>
            }
            key="dataExpenseManagementAndVirtualCardUsers"
            disabled={!isVcpEnabled}
          >
            <Table
              id="dataExpenseManagementAndVirtualCardUsersTable"
              dataSource={dataSource?.dataExpenseManagementAndVirtualCardUsers}
              columns={columns}
              pagination={pagination}
              scroll={{ x: true, y: 300 }}
            />
          </Tabs.TabPane>
        </Tabs>

        <Section>
          <Form.Item
            style={{
              display: isAllSSPUsersAdded ? 'none' : 'block',
            }}
            name={['administrator', 'selfServiceUsers']}
            rules={[
              { validator: validateArrayNotEmpty }, // Apply the custom validator
            ]}
          />

          <Form.Item
            name={['administrator', 'selfServiceUsers']}
            rules={[
              { validator: areAllRolesSelected }, // Apply the custom validator
            ]}
          />

          <Form.Item
            style={{
              display: isAllDataExpenseManagementUsersAdded ? 'none' : 'block',
            }}
            name={['administrator', 'dataExpenseManagementAndVirtualCardUsers']}
            rules={[
              { validator: validateArrayForAtLeastThreeValues }, // Apply the custom validator
            ]}
          />
        </Section>
        <AdministratorAdd
          {...props}
          isSpinning={isSpinning}
          setIsSpinning={setIsSpinning}
          index={recordIndex}
          onSave={onSave}
          handleEdit={handleEdit}
          handleDelete={handleDelete}
          adminType={activeTab}
          selectedValue={selectedValue}
          setSelectedValue={setSelectedValue}
          isDisabled={isAddFormDisabled || isDisabledForSoftRejection || isActiveTabDisabled}
          applicationData={applicationData}
          servicesDetailsData={servicesDetailsData}
        />
        <DeleteConfirmationModal visible={deleteModalVisible} onDelete={onDelete} onCancel={onCancel} />
        <Form.Item hidden name={['administrator', 'dataExpenseManagementAndVirtualCardUsers']} />
      </Form>
    </Container>
  );
};
const Container = styled.div<any>`
  .Administrator-Tabs {
    .Tabs-Title {
      line-height: 22px;
      font-size: 14px;
      font-weight: 500;
    }
    .ant-tabs-nav-list {
      background: rgb(255, 255, 255);
      border-bottom: 1px solid rgb(228, 228, 228);
    }
  }
  .Tabs-Title {
    color: #000;
  }
  .ant-tabs-tab-disabled .Tabs-Title {
    color: gray;
  }
  ${({ isActiveTabDisabled }: any) =>
    isActiveTabDisabled &&
    `
    .ant-tabs-ink-bar::after {
      display: none;
    }
  `}
  .ant-tabs-ink-bar {
    height: 5px;
    background: transparent;
  }

  .ant-tabs-ink-bar::after {
    content: ' ';
    position: absolute;
    left: 50%;
    right: 0;
    bottom: -1px;
    height: 2px;
    background: #e64360;
    width: 100%;
    transform: translateX(-50%);
  }
  .ant-tabs-nav-wrap::after {
    position: absolute;
    z-index: 1;
    opacity: 0;
    transition: opacity 0.3s;
    content: '';
    pointer-events: none;
  }
  .rotate-90 {
    transform: rotate(90deg);
  }
  .ant-table {
    background: #fff;
  }
  .ant-table-tbody {
    .ant-btn {
      background: transparent;
      border: none;
    }
    .ant-btn:hover {
      background: transparent;
      color: #000;
    }
  }
`;

export default Administrator;
